<template>
  <v-dialog v-model="show" max-width="700" scrollable>
    <v-form ref="form" @submit.prevent="submit">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.stop="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ WindowLable }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-text-field v-model="title" label="Name" :rules="inputRules" />
          <div>
            <v-text-field v-if="EditMode===true"
             v-model="marginalFileName" 
             label="Data File Name"
             readonly
            />
            <v-row>
              <v-col>
            <v-file-input
              label="Data File"
              :v-model="fileData"
              @change="getFile"
              :rules="EditMode!== true ? inputRules : []"
             
              >
            </v-file-input>
              </v-col>
              <v-col>
                <v-text-field
                v-model="year" 
                label="Year"
                />
              </v-col>
            </v-row>
          </div>
          <v-checkbox v-model="isPublished" color="primary" hide-details>
            <template v-slot:label> Published </template>
          </v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="primary" @click.stop="show = false"
            >Close</v-btn
          >
          <v-btn outlined color="primary" @click="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
      <MessageBox
      confirmationTitle="Error in input file"
      :bodyText="errorDescription"
      :visible="isSowfinalMessage"
      @closeBox="closeBox(erroFileInput)"
    />
    </v-form>
  </v-dialog>
</template>
<script>
import csvFile from "@/services/csvFile";
import MessageBox from "@/components/messageBox.vue";
import { bus } from "../main";
import marginalCost from "@/libs/marginalCostOfReplacedEnergyRecordsService";
import MarginalCostStore from "@/services/marginalcoststore.js";
export default {
  name: "newEditMarginalCost",
  props: ["visible", "MarginalData", "EditMode", "WindowLable","source"],
  components: {MessageBox},
  data() {
    return {
      errorDescription: "",
      isSowfinalMessage: false,
      marginalFileName :"",
      dataSource:'',
      isPublished: false,
      fileData: null,
      year:"",
      feederProfilefile: null,
      dialog: false,
      id: null,
      title: "",
      date: "",
      Notification: false,
      errorMsg: null,
      response: [],
      LatestData:[],
      inputRules: [(v) => !!v || "This field is required"],
      numberRules: [
        (v) => !!v || "Required",
        (v) => v >= 0 || "Negative value not allowed",
        (v) => v <= 1000 || "Max should not be 1000 ",
      ],
    };
  },

  computed: {
    show: {
      get() {
        if (this.EditMode) {
          this.FillData();
        }

        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close", this.response);
        }
      },
    },
  },
  methods: {
    closeBox(ctrl) {
      this.isSowfinalMessage = false;
    },
    showMessage(ctrl) {
      this.erroFileInput = ctrl;
      this.isSowfinalMessage = true;
    },
    initFormControls(){
      this.isPublished = false
      this.fileData=""
      this.title=""
    },
    onFileChange(file, ctrl) {
      console.log("file", file);
      if (file) {
        const isV_ModelTrigger =
          file.name.split("_").pop() === "finalFile" ? true : false;
        if (!isV_ModelTrigger) {
          this.validateCsv(file, ctrl);
        }
      }
    },
    validateCsv(file, ctrl) {
      let isGreaterValueValidattion = false;

      return csvFile.isValideCSV(file, isGreaterValueValidattion).then((a) => {
        if (a && a.status === false) {
          this.erroFileInput = ctrl;
          this.errorDescription = a.message;
          this.showMessage(ctrl);
          return false;
        } else if (a && a.data && a.status === true) {
          this.setCSVDataToVModel(a.data[0], ctrl);
          return true;
        }
      });
    },

    setCSVDataToVModel(csvdata, ctrl) {
      this.fileData = csvdata;
      
    },
    FillData() {

      this.id = this.MarginalData._id;
      this.title = this.MarginalData.title;
      this.year = this.MarginalData.year;
      this.isPublished = this.MarginalData.isPublished;
      this.date = this.MarginalData._updated;
      if(this.MarginalData.csvFile.name)
      this.marginalFileName = this.MarginalData.csvFile.name;
    },
    async saveAction(payload,_status,statusMessage) {
       bus.$emit("SaveNotification",_status,statusMessage)
     if(_status==='OK'){
      bus.$emit("justAdded",await this.getLatestRecord(payload._id))
      this.$refs.form.reset();
      this.initFormControls();
      this.show = false
     }
    },
    async upodateAction(payload,_status,statusMessage) {
       bus.$emit("updateNotification",_status,statusMessage)
      if(_status==='OK'){
        bus.$emit("justEdited", await this.getLatestRecord(payload._id))
        this.initFormControls();
        this.show = false
      }
    },
    async getLatestRecord(id){
      const res = await marginalCost.getMarginalCost(id);
      return res.data
    },
    getFile(file) {
      this.fileData = file;
      this.onFileChange(this.fileData, 'fileData');
    },
    submit() {
     const s=this.source;
      if (this.$refs.form.validate()) {
        const payload = {
          title: this.title,
          csvFile: this.fileData,
          year: this.year,
          isPublished: this.isPublished,
        };
        this.Loading = true;
        if (this.EditMode === false) {
          MarginalCostStore.methods
            .addmarginalCostOfReplacedEnergyRecords(payload)
            .then((res) => {
              const currenData = {
                _id: res._id,
                title: this.title,
                year:this.year,
                isPublished: this.isPublished,
                _updated: res._updated,
              };
               this.saveAction(currenData,res._status)
            })
            .catch((error) => {
              this.saveAction(null,400,error,s)
            });
        } else if (this.EditMode === true) {
          const payload = {
          title: this.title,
          year: this.year,
          isPublished: this.isPublished
        };
         if(this.fileData !==''){
             payload["csvFile"] = this.fileData;
            }
           
          MarginalCostStore.methods
            .edit(this.id,payload)
            .then((res) => {
              const currenData = {
                _id:res._id,
                title: this.title,
                year: this.year,
                _updated:res._updated,
                isPublished : this.isPublished
              };
              this.upodateAction(currenData,res._status)
            })
            .catch((error) => {
              this.upodateAction(400,error)
            });
        }
      }
    }
  },
};
</script>